import styled from '@emotion/styled';
import classNames from 'classnames';
import React, { TableHTMLAttributes } from 'react';
import { colors, semantic_colors } from '../../foundation';
import { getAutoColorCode } from '../../styles';

interface TableRowProps extends TableHTMLAttributes<HTMLTableRowElement> {
  selected?: boolean;
  isEmpty?: boolean;
  cellHoverStyle?: boolean;
  clickable?: boolean;
  selectable?: boolean;
  disabled?: boolean;
  rowColor?: string;
}

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <StyledTableRow ref={ref} className={classNames('pds-table-row', className)} {...props}>
        {children}
      </StyledTableRow>
    );
  },
);

const StyledTableRow = styled.tr<{
  selected?: boolean;
  isEmpty?: boolean;
  cellHoverStyle?: boolean;
  clickable?: boolean;
  selectable?: boolean;
  disabled?: boolean;
  rowColor?: string;
}>`
  transition: background-color 0.1s linear;
  background-color: ${semantic_colors.background.surface};

  ${({ rowColor, selected }) =>
    (selected || rowColor) &&
    `& > td {
      background-color: ${selected ? semantic_colors.accent.light : rowColor};
    }`}

  ${({ isEmpty, selected, cellHoverStyle, rowColor }) =>
    !isEmpty &&
    !selected &&
    cellHoverStyle &&
    `
    &:hover > td {
      background-color: ${rowColor ? getAutoColorCode(rowColor).hover : colors.gray10};
    }
`}
`;
